var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumpsDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.248,
    height: 20,
    viewBox: "0 0 19.248 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_80",
    "data-name": "Union 80",
    d: "M4.748,2.929H1.219A1.218,1.218,0,0,0,0,4.148V14.811A1.218,1.218,0,0,0,1.219,16.03H4.748a1.218,1.218,0,0,0,1.218-1.217v-.29a2.091,2.091,0,0,1,1.492,1.218l1.777,3.732a3.92,3.92,0,0,1,.342,1.141l.182,1.316a.6.6,0,0,0,.02.087,1.289,1.289,0,0,0,1.255.912h.075a2.753,2.753,0,0,0,1.967-1.255,3.858,3.858,0,0,0,.117-3.312,5.772,5.772,0,0,1-.424-2.6,18.3,18.3,0,0,0,4.3-.365H17.1a2.313,2.313,0,0,0,.936-.414,2.061,2.061,0,0,0,.158-.135,2.234,2.234,0,0,0,.558-2.554,2.56,2.56,0,0,0,.5-1.387,2.664,2.664,0,0,0-.609-1.758,2.68,2.68,0,0,0-.792-2.977,2.657,2.657,0,0,0-1.781-2.868,4.491,4.491,0,0,0-1.812-.361H9.1a4.622,4.622,0,0,0-2.38.66l-.756.453A1.218,1.218,0,0,0,4.751,2.929Zm0,1.712V4.148S1.9,7.727,1.9,10.393a15,15,0,0,0,.343,3.813L2.42,12.3ZM10.317,16.03l2.072,5.248a19.82,19.82,0,0,0-.41-3.027L10.317,8.941c-.438-1.025,2.81-1.617,1.712-1.81l-.709.442L5.966,5.478l8.284,8.728c.529-.318-1.677-5.051-1.059-5.052l1.422-4.513c-1.229,1.48-1.846,3.438-1.422,3.616.959.421.628.911,1.588-.116-.017.023-.257-.277-.276-.222-.085.253-2.079.862-1.866,1.022.718.41,1.718.441,1.327,1.169-.14.234-.463.492-.276.69.336.3.4-.7.415-.249-.029.336,2.918.8,2.681,1.043-.223.2.572.685.733.937l.242-.336L14.252,8.257l2.138,4.275a13.36,13.36,0,0,0,1.642,0L13.191,4.641c-1.363.276.228,5.8-1.162,5.752-.518,0,.237-3.324.123-2.82-.144,1.133-1.343-1.209-.912-.151a6.494,6.494,0,0,1,.257,3.531S9.964,6.759,11.02,5.686s-1.786,1.1-1.786,1.1,1.091,9.25,1.082,9.243ZM2.24,6.044A.743.743,0,1,0,2.983,5.3a.743.743,0,0,0-.743.744Z",
    transform: "translate(0 -2.929)",
    fill: "#E10092"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3831",
    "data-name": "Group 3831",
    transform: "translate(-58.445 -732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3827",
    "data-name": "Group 3827",
    transform: "translate(58.445 732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3825",
    "data-name": "Group 3825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3824",
    "data-name": "Group 3824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25",
    "data-name": "Mask Group 25",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24651",
    "data-name": "Path 24651",
    d: "M0,27.044H27.553V0H0Z",
    transform: "translate(-5.909 -1.327)",
    fill: "#E10092"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1463",
    "data-name": "Rectangle 1463",
    width: 1.327,
    height: 1.327,
    transform: "translate(11.025 4)",
    fill: "#E10092"
  })))))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(61 734.5)",
    fill: "#E10092"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumpsDownFilled);
export default __webpack_public_path__ + "static/media/thumps-down-filled.2eae7edd990ac3027ac02f8df3c3391f.svg";
export { ForwardRef as ReactComponent };